export const saveFile = (function () {
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    a.remove();
    return function (blob: Blob, fileName: string) {
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    };
}());

export function openPdf(url?: string){
    if(url !== undefined)
    {
        var pdfWindow = window.open(url, '_blank', 'noreferrer');
        var timer = setInterval(checkChild, 500);
        function checkChild() {
            if (pdfWindow!.closed) {
                URL.revokeObjectURL(url!);
                clearInterval(timer);
            }
        }
    }
}
